import { Injectable } from "@angular/core";
import { AuditLogResponse, AuditLog } from "../models/audit-log";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import * as moment from "moment";
import { HttpClient } from "@angular/common/http";

const URL = environment.apiBaseUrl;

@Injectable()
export class AuditLogService {
  constructor(private http: HttpClient) {}

  public auditLogs(
    startDate: Date,
    endDate: Date,
    startRow: number,
    endRow: number,
    sortCol: string,
    sortDesc: boolean
  ): Observable<AuditLogResponse> {
    const startDateStr = moment(startDate).format("M/D/YYYY");
    const endDateStr = moment(endDate).format("M/D/YYYY");

    const url =
      `${URL}auditLog?startRow=${startRow}&endRow=${endRow}&sortColumn=${sortCol}&sortDescending=${sortDesc}` +
      `&startDate=${startDateStr}&endDate=${endDateStr}`;

    return this.http.get(url).map((x: any) => {
      const res = new AuditLogResponse();
      res.auditLogs = x.data as AuditLog[];
      res.total = x.total;
      return res;
    });
  }
}
